import { SERVICE_BRAND } from '@/config';
import { documentationUrl } from '@/i18n/documentation';
import FrontendService from '@/services/FrontendService';
import LanguageSwitcher from '@/components/layout/LanguageSwitcher/LanguageSwitcher.vue';
import developerLogo from '@/assets/logo-without-text_120px.webp';
import stoolsImage from '@/assets/stools.webp';

export default {
  name: 'FooterV2',
  components: { LanguageSwitcher },

  data() {
    return {
      themeMode: FrontendService.getThemeMode(),
      showSocialLinks: false,
    };
  },

  mounted() {
    this.themeMode = FrontendService.getThemeMode();
    window.addEventListener(FrontendService.THEME_CHANGED_EVENT, this.handleThemeChanged);
  },

  beforeUnmount() {
    window.removeEventListener(FrontendService.THEME_CHANGED_EVENT, this.handleThemeChanged);
  },

  computed: {
    documentationHref() {
      return documentationUrl(this.$i18n.locale);
    },

    brandLogo() {
      return SERVICE_BRAND.logo;
    },

    developerLogo() {
      return developerLogo;
    },

    stoolsImage() {
      return stoolsImage;
    },

    brandTitle() {
      const full = SERVICE_BRAND.full || {};
      return [full.left, full.highlight, full.right]
        .map((part) => String(part || '').trim())
        .filter(Boolean)
        .join(' ');
    },

    themeIconClass() {
      return FrontendService.getThemeIconClass(this.themeMode);
    },

    themeButtonLabel() {
      return this.$t(`theme.${this.themeMode}`);
    },
  },

  methods: {
    toggleTheme() {
      this.themeMode = FrontendService.toggleThemeMode(this.themeMode);
    },

    /**
     * Синхронизирует локальное состояние футера при смене темы из другого компонента.
     * @param {CustomEvent<{ mode: 'light'|'bright'|'contrast'|'dark' }>} event
     */
    handleThemeChanged(event) {
      if (FrontendService.isValidThemeMode(event?.detail?.mode)) {
        this.themeMode = event.detail.mode;
      }
    },
  },
};
